<style scoped>
.expand-row {
  margin-bottom: 16px;
}
</style>
<template>
  <div>
    <Row class="expand-row">
      <Table :columns="columns8" :data="row.arr"> </Table>
      <!-- <Col span="8">
        <span class="expand-key">Job: </span>
        <span class="expand-value">{{ row.xbid }}</span>
      </Col>
      <Col span="8">
        <span class="expand-key">Interest: </span>
        <span class="expand-value">{{ row.xbsort }}</span>
      </Col> -->
    </Row>
  </div>
</template>
<script>
export default {
  props: {
    row: Object,
  },
  data() {
    return {
      columns8: [
        {
          title: "小板id",
          key: "machineid",
        },
        {
          title: "座位号",
          key: "sort",
        },
        {
          title: "识别小板号",
          key: "videomachineid",
        },
        {
          title: "一个彩票等于多少币",
          key: "piaonum",
        },
        {
          title: "游戏状态",
          key: "type",
          minWidth: 90,
          render: (h, params) => h("span", String(params.row.type) === "1" ? "游戏中" : "空闲"),
        },
        {
          title: "玩家所属 App",
          key: "gameApp",
          minWidth: 140,
          render: (h, params) => {
            const row = params.row;
            if (String(row.type) !== "1") return h("span", "—");
            const colors = new Map([
              ["twservice", "#ed4014"],
              ["newservice", "#2d8cf0"],
              ["newclaw", "#19be6b"],
            ]);
            return h("span", {
              style: { color: colors.get(row.gameTag) || "#808695" },
            }, row.gameApp || "未知");
          },
        },
        {
          title: "操作",
          key: "action",
          width: 240,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerReturnOrder", [
                        {
                          ...params.row,
                          videomachineid: params.row && params.row.videomachineid,
                        },
                      ]);
                    },
                  },
                },
                "游戏记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.$emit("triggerDelete", [params.row]);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
};
</script>
